/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PersonDetails({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/PersonDetails"
  
}) {
let relationshipFromPersonRecordValueData = fromData.useDataFormat({ viewPath,
context: 'relationship',
path: 'from_person_record',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="relationship.from_person_record"
 format="/Data/format.js personName"
 text={relationshipFromPersonRecordValueData}
/>
{children}
</React.Fragment>)
}